import { TextField, Typography } from "@mui/material";
import { Controller } from "react-hook-form";

interface Props {
  label?: string;
  name: string;
  size?: "small" | "medium";
  control: any;
  multiline?: boolean;
  required?: boolean;
  inputProps?: any;
  InputProps?: any;
  disable?: boolean;
  type?: string;
}

function FormInput(props: Props) {
  const {
    name,
    size = "small",
    control,
    label = "",
    multiline,
    required = false,
    inputProps = {},
    InputProps = null,
    disable = false,
    type = "text",
  } = props;

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <TextField
              error={Boolean(error)}
              disabled={disable}
              variant="outlined"
              label={`${label} ${required ? "*" : ""}`}
              fullWidth
              multiline={multiline}
              rows={multiline ? 3 : 1}
              size={size}
              inputProps={inputProps}
              type={type}
              InputProps={{
                endAdornment: InputProps,
              }}
              {...field}
            />
            {error && (
              <Typography
                variant="caption"
                sx={{ pl: "2px", display: "block" }}
                color="rgb(211, 47, 47)"
              >
                {error.message}
              </Typography>
            )}
          </>
        )}
      />
    </>
  );
}

export default FormInput;
